import { render, staticRenderFns } from "./CheckerboardItem.vue?vue&type=template&id=6bc8d392"
import script from "./CheckerboardItem.vue?vue&type=script&lang=js"
export * from "./CheckerboardItem.vue?vue&type=script&lang=js"
import style0 from "./CheckerboardItem.vue?vue&type=style&index=0&id=6bc8d392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports